'use strict';exports.__esModule = true;var _constants = require('../constants');
var _scriptLoaders = require('./scriptLoaders');function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

CaptchaService =



function CaptchaService(locale, done) {var _this = this;_classCallCheck(this, CaptchaService);_initialiseProps.call(this);
  var adaptedLocale = this.correctLocaleForCaptcha(locale);

  if (global.grecaptcha && this.locale === adaptedLocale) {

    done(this);
  } else {
    (0, _scriptLoaders.googleReCaptchaLoader)(adaptedLocale).
    then(function (captcha) {
      _this.locale = adaptedLocale;
      _this.captcha = captcha;
      _this.captcha.ready && _this.captcha.ready(function () {return done(_this);});
    }).
    catch(this.handleError);
  }
};var _initialiseProps = function _initialiseProps() {var _this2 = this;this.captcha = null;this.locale = null;this.

  render = function (container, callback) {var invisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;var expiredCallback = arguments[3];var errorCallback = arguments[4];return _this2.captcha.render(container, Object.assign({
      sitekey: _constants.googleReCaptchaConfig.apiKey,
      callback: callback,
      expiredCallback: expiredCallback,
      errorCallback: errorCallback },
    invisible ? { size: 'invisible' } : {}));};this.


  execute = function (captchaId) {return _this2.captcha.execute(captchaId);};this.

  reset = function (captchaId) {return _this2.captcha.reset(captchaId);};this.

  correctLocaleForCaptcha = function (locale) {
    // Full locales for google reCaptcha - https://developers.google.com/recaptcha/docs/language
    var correctedLocale = locale;

    switch (locale) {
      case 'he':{
          correctedLocale = 'iw';
          break;
        }
      default:correctedLocale = locale;}


    return correctedLocale;
  };this.

  handleError = function (err) {
    // Avoid logging server side load script error
    if (!err.code || err.code !== 'SSR') {
      console.error('Captcha error:', err);
    }
  };};exports.default = CaptchaService;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/captchaService.js
// module id = 3064
// module chunks = 0